// src/Sidebar.js
import React from "react";
import "./sidebarr.css";
import logo from "../../../utilities/gg-logo.png";

import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import SwitchAccountOutlinedIcon from "@mui/icons-material/SwitchAccountOutlined";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import AddReactionOutlinedIcon from "@mui/icons-material/AddReactionOutlined";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";

const Sidebar = (props) => {
  const user = props.user;
  const roleText = (user?.role || "Manager").toString();
  const displayName = (user?.name || "User").toString();
  const initials = displayName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("") || "U";
  const pendingLeaveCount = Number(props.pendingLeaveCount || 0);

  const dashClass = props.dashbaordToggle ? "activeNav" : "deactivateNav";
  const addEmpClass = props.addEmployeeToggle ? "activeNav" : "deactivateNav";
  const docsClass = props.docsToggle ? "activeNav" : "deactivateNav";
  const progRepClass = props.progressReportsToggle
    ? "activeNav"
    : "deactivateNav";
  const reqdLvsClass = props.requestedLeavesToggle
    ? "activeNav"
    : "deactivateNav";
  const pastTimClass = props.pastTimersToggle ? "activeNav" : "deactivateNav";
  const projClass = props.projectsToggle ? "activeNav" : "deactivateNav";
  const empDetailClass = props.employeeDetailsToggle
    ? "activeNav"
    : "deactivateNav";
  const eventClass = props.eventsToggle ? "activeNav" : "deactivateNav";
  const countClass = props.myCountdownToggle ? "activeNav" : "deactivateNav";
  const reqALeaveClass = props.requestALeaveToggle
    ? "activeNav"
    : "deactivateNav";
    const ideasClass = props.ideasToggle
    ? "activeNav"
    : "deactivateNav";
  const attendanceClass = props.attendanceToggle ? "activeNav" : "deactivateNav";
  const projShowClass = props.projectShowcaseToggle ? "activeNav" : "deactivateNav";
  const attEditClass = props.attendanceEditorToggle ? "activeNav" : "deactivateNav";

  return (
    <div className="sidebar-space">
      <div className={`sidebar ggSidebar animate__animated animate__fadeInLeft`}>
        <div className="side-content">
          <div className="ggSidebarTop">
            <div className="ggLogoRow">
              <div className="ggLogoBadge" aria-hidden="true">
                <img className="ggLogoImg" src={logo} alt="Growth Guild" />
              </div>
              <div className="ggBrandText">
                <div className="ggBrandTitle">GROWTH</div>
                <div className="ggBrandSub">GUILD HRMS</div>
              </div>
            </div>
            <div className="ggDivider" />

            <div className="ggRoleBadge">
              <span className="ggRoleText">{roleText}</span>
            </div>
          </div>
          <div className="buttons">
            {/* EMPTY */}
            <button
              className={`navButton ggNavItem ${dashClass}`}
              onClick={props.onDashboard}
            >
              <span className="ggNavLeft">
                <DashboardOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Dashboard</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${addEmpClass}`}
              onClick={props.onAddEmployee}
            >
              <span className="ggNavLeft">
                <PersonAddOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Add Employee</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${progRepClass}`}
              onClick={props.onShowProgress}
            >
              <span className="ggNavLeft">
                <EqualizerOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Progress Reports</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${reqdLvsClass}`}
              onClick={props.onShowLeaves}
            >
              <span className="ggNavLeft">
                <CollectionsBookmarkOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Requests</span>
              </span>
              {pendingLeaveCount > 0 ? (
                <span className="ggPillBadge" aria-label={`Pending requests: ${pendingLeaveCount}`}>
                  {pendingLeaveCount}
                </span>
              ) : null}
            </button>
            <button
              className={`navButton ggNavItem ${pastTimClass}`}
              onClick={props.onShowTimers}
            >
              <span className="ggNavLeft">
                <HistoryOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Online History</span>
              </span>
            </button>
            {props.showAttendanceEditor && (
              <button
                className={`navButton ggNavItem ${attEditClass}`}
                onClick={props.onShowAttendanceEditor}
              >
                <span className="ggNavLeft">
                  <EditCalendarOutlinedIcon className="ggNavIcon" />
                  <span className="ggNavLabel">Edit Attendance</span>
                </span>
              </button>
            )}
            {/* <button
              className={`navButton ${projClass}`}
              onClick={props.onShowProjectA}
            >
              <CategoryOutlinedIcon sx={{ marginTop: "-5px" }} />
              &nbsp; Projects
            </button> */}
            <button
              className={`navButton ggNavItem ${empDetailClass}`}
              onClick={props.onShowProfile}
            >
              <span className="ggNavLeft">
                <SwitchAccountOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Employee Details</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${docsClass}`}
              onClick={props.onShowDocs}
            >
              <span className="ggNavLeft">
                <PersonOutlineIcon className="ggNavIcon" />
                <span className="ggNavLabel">Docs</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${eventClass}`}
              onClick={props.onShowEvents}
            >
              <span className="ggNavLeft">
                <CelebrationOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Upcoming Events</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${countClass}`}
              onClick={props.onMyCountdown}
            >
              <span className="ggNavLeft">
                <SpeedOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Countdown</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${reqALeaveClass}`}
              onClick={props.onRequestALeave}
            >
              <span className="ggNavLeft">
                <AddReactionOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Request A Leave</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${ideasClass}`}
              onClick={props.onShowIdeas}
            >
              <span className="ggNavLeft">
                <TipsAndUpdatesIcon className="ggNavIcon" />
                <span className="ggNavLabel">Ideas Board</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${attendanceClass}`}
              onClick={props.onShowAttendance}
            >
              <span className="ggNavLeft">
                <CalendarMonthOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Attendance</span>
              </span>
            </button>
            {props.showProjectShowcase && (
              <button
                className={`navButton ggNavItem ${projShowClass}`}
                onClick={props.onShowProjectShowcase}
              >
                <span className="ggNavLeft">
                  <AutoAwesomeOutlinedIcon className="ggNavIcon" />
                  <span className="ggNavLabel">Project Showcase</span>
                </span>
              </button>
            )}
          </div>
        </div>

        <div className="ggSidebarBottom">
          <div className="ggDivider" />
          <div className="ggUserPanel">
            <div className="ggAvatar" aria-hidden="true">
              {initials}
            </div>
            <div className="ggUserText">
              <div className="ggUserName">{displayName}</div>
              <div className="ggUserRole">{roleText}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
